module.exports = __webpack_public_path__ + "static/media/creedforher.1adca0a6.png";